<button class="btn icon-letter header-button" matTooltip="Refer friends" (click)="openInviteFriendDialog()"></button>
